import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SpeakerPhoneIcon(props: IconProps) {
    return <Icon {...props} iconKey={"speaker_phone"}/>
}
